export enum ChartDataSource {
  none = "none",
  demo = "demoData",
  polling = "pollingData",
}
